<template lang="pug">
  .pergunta
    div(v-if='media.length')
      light-box(:ref='lightBoxRef' :media="media" :showLightBox="false")
    .titulo {{ pergunta.titulo}}
    .resposta(v-if='[undefined, null].includes(pergunta.resposta)') -
    .resposta(v-else-if='pergunta.alternativas')
      .alternativa(v-for='a in pergunta.alternativas' :key='a.id')
        div(:class="{'text-muted': !isIncludeAlternativa(pergunta, a)}")
          i.fa.fa-check-square-o(:class='iconClassAlternativa(pergunta, a)')
          span  {{ a.titulo }}
    .resposta(v-else-if="tiposBoolean.includes(pergunta.tipo)")
      | {{ pergunta.resposta ? 'Sim' : 'Não' }}
    .resposta(v-else-if="pergunta.tipo === 'time'") {{ pergunta.resposta | date('HH:mm') }}
    .resposta(v-else-if="pergunta.tipo === 'date'") {{ pergunta.resposta | date('DD/MM/YYYY') }}
    .resposta(v-else-if="pergunta.tipo === 'decimal'") {{ pergunta.resposta | currency }}
    .resposta(v-else-if="pergunta.tipo === 'notificar'") Documento Nº
      a.btn.btn-link(:href="pergunta.resposta.url" target="_blank")
        | {{ pergunta.resposta.numero }}/{{ pergunta.resposta.ano}}
    .resposta(v-else) {{ pergunta.resposta }}
    .fotos(v-if='pergunta.fotos && pergunta.fotos.length > 0')
      .columns.mt-2
        .column.col-auto.my-1(v-for="foto, index in pergunta.fotos")
          .card.foto
            .card-image
              img.s-rounded.img-responsive(:src="foto.thumb" @click="openImage(index)")
              .text-right(v-if='foto.geolocation')
                button.btn.btn-link(@click='openMap(foto)')
                  i.fa.fa-map-pin
    foto-map-modal(:active='showMap', title='Mapa do local da foto' :foto='fotoMap' @close='closeMap()')
</template>

<script>
export default {
  props: { pergunta: { type: Object, required: true } },

  data() {
    return {
      showMap: false,
      fotoMap: null,
      tiposBoolean: [
        'sim_nao',
        'verificar_notificacao',
        'verificar_desconto',
        'verificar_alvara_vencido',
        'local_acessivel',
      ],
    }
  },

  computed: {
    media() {
      if (this.pergunta && this.pergunta.fotos) {
        return this.pergunta.fotos.map(foto => ({
          thumb: foto.thumb,
          src: foto.url,
        }))
      }

      return []
    },

    lightBoxRef() {
      return 'lightBox_' + this.pergunta.id
    },
  },

  methods: {
    iconClassAlternativa(pergunta, alternativa) {
      const checked = this.isIncludeAlternativa(pergunta, alternativa)
      if (pergunta.tipo === 'checkbox') {
        return checked ? 'fa-check-square-o' : 'fa-square-o'
      }

      return checked ? 'fa-check-circle-o' : 'fa-circle-o'
    },

    isIncludeAlternativa(pergunta, alternativa) {
      if (pergunta.tipo === 'checkbox') {
        if (pergunta.resposta.includes(alternativa.id)) {
          return true
        }
      }

      return pergunta.resposta === alternativa.id
    },

    openMap(foto) {
      if (foto && foto.geolocation) {
        this.fotoMap = foto
        this.showMap = true
      }
    },

    closeMap() {
      this.showMap = false
      this.fotoMap = null
    },

    openImage(index) {
      if (this.pergunta.fotos[index].type === 'pdf') {
        window.open(this.pergunta.fotos[index].url)
      } else {
        this.$refs[this.lightBoxRef].showImage(index)
      }
    },
  },
  created() {
    window.vue = this
  },
}
</script>
